const colors = {
  brand: {
    100: "#E9F2FF",
    200: "#e9a9eb",
    300: "#9AC5FF",
    400: "#72AEFF",
    500: "#C157F9",
    600: "#227DF7",
    700: "#0B5ECE",
    800: "#0046A5",
    900: "#00357D",
    1000: "#000342",
    1100: "#ffffff0d",
    1200: "#d17ffc",
    1500: "#eba5f0"
  },
  secondary: {
    200: "#FFD6D0",
    400: "#FF998A",
    500: "#D45454",
    600: "#E83D3D",
    800: "#35DC86"
  },
  white: "#ffffff",
  purple: "#C157F9",
  lightpurple: "#da8ee7",
  gradient: "linear-gradient(48deg, #7855f8 11%, #c157f9 82%)",
  modal: "rgba(60,60,60,0.8)",
  whiteAlpha: {
    100: "rgba(255, 255, 255, 0.1)",
    200: "rgba(255, 255, 255, 0.2)",
    300: "rgba(255, 255, 255, 0.3)",
    400: "rgba(255, 255, 255, 0.4)",
    500: "rgba(255, 255, 255, 0.5)",
    600: "rgba(255, 255, 255, 0.6)",
    700: "rgba(255, 255, 255, 0.7)",
    800: "rgba(255, 255, 255, 0.8)",
    900: "rgba(255, 255, 255, 0.9)"
  }
};

export default colors;
